export default __webpack_public_path__ + "static/media/bandeira-dos-estados-unidos.a7f9a771.svg";